const domain = {
	img: "http://img.myzc88.com",
	ossimg: "http://newmyzcoss.oss-cn-hangzhou.aliyuncs.com/",
}
export default {
	domain
};